// Clinic Configuration for 
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Lawrenceville Dentistry",
  clinicId: "lawrencevilledentistry",
  clinicUrl: "https://lawrencevilledentistry.com",
  // Contact Information
  phoneNumber: "770-415-0077",
  phoneNumberRaw: "+17704150077", // For tel: and sms: links
  email: "Dentist@LawrencevilleDentistry.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=lawrencevilledentistry&agentId=2954102d-85d2-455b-91c3-cbabbd9c51d3",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/lawrencevilledentistry/voice",

  // Location
  address: "1455 Pleasant Hill Road ,Lawrenceville, Suite 807A , Georgia  30044, USA",
  addressShort: "1455 Pleasant Hill Road ,Lawrenceville, Suite 807A , Georgia  30044",
  city: "Lawrenceville",
  hcity: "Lawrenceville",
  state: "Georgia",
  stateShortForm: "GA",
  PostalCode: "30044",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/MFnMPmHSsdyHaGZe9",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1533643.5314877587!2d-84.12409700000002!3d33.940562!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a3054f3018bf%3A0xe3a731dab4ba7742!2sLawrenceville%20Dentistry!5e1!3m2!1sen!2sin!4v1756802933329!5m2!1sen!2sin',
  iframeTitle: "Lawrenceville Dentistry",

  //membership
  membership: "https://member.kleer.com/?slug=DK2P",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinLawrenceville",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/lawrenceville-dentistry?utm_source=practice&utm_medium=email&m=65972",


  // Analytics
  clarityProjectId: "prcvlw68k2",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/lawrencevilledentistry",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/lawrencevilledentistry",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/lawrencevilledentistry",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://lawrencevilledentistry.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/LawrencevilleDentistry",
    instagram: "https://www.instagram.com/lawrencevilledentistry/",
    twitter: "https://x.com/LvilleDental",
    linkedin: "https://www.linkedin.com/company/lawrenceville-dentistry/",
    youtube: "https://www.youtube.com/@dentistinlawrenceville",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/357268982404979843/profile?hl=en-GB&fid=16404134983125071682",
    facebook: "https://www.facebook.com/LawrencevilleDentistry",
    yelp: "https://www.yelp.com/biz/lawrenceville-dentistry-lawrenceville",
  },

  // Open Dental Configuration
  defaultProvNum: 67,
  defaultOpNum: 21,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 22,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 21,
      AppointmentTypeNum: 3
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 21,
      AppointmentTypeNum: 16
    }
  ],



  // Twilio Configuration
  twilioPhoneNumber: "17707669974",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
